<template>
	<div
		data-component="card-select"
	>
		<select-field
			ref="selectField"
			v-if="showField"
			htmlOptions
			:name="name"
			:id="id"
			:rules="rules"
			:hasPlaceholder="false"
			:hasLabel="false"
			:selectLabel="''"
			:deselectLabel="''"
			:selectedLabel="''"
			:emptyAllowed="emptyAllowed"
			:showNoOptions="false"
			:disabled="disabled"
			:multiple="multiple"
			:hideSelected="hideSelected"
			:options="options"
			validationSize="sm"
			v-model="getCard"
		/>
	</div>
</template>

<script>

	import SelectField from '@/components/forms/SelectField';

	export default {
		components: {
			SelectField
		},
		props: {
			name: {
				type: String,
				default: 'Card'
			},
			id: {
				type: String,
				default: undefined
			},
			value: {
				type: [String, Array],
				default: undefined
			},
			rules: {
				type: [
					String,
					Object
				],
				default: ''
			},
			options: {
				type: Array,
				default () {
					return [];
				}
			},
			disabled: {
				type: Boolean,
				default: false
			},
			multiple: {
				type: Boolean,
				default: false
			},
			hideSelected: {
				type: Boolean,
				default: false
			},
			emptyAllowed: {
				type: Boolean,
				default: false
			},
			renderOnChange: {
				type: Boolean,
				default: false
			}
		},
		data: () => ({
			showField: true
		}),
		computed: {
			getCard: {
				get () {
					return this.value;
				},
				set (newVal) {
					this.$emit('input', newVal);
				}
			}
		},
		watch: {
			value (value) {
				if (this.renderOnChange) {
					this.$refs.selectField.setValue(value);
				}
			}
		}
	};

</script>

<style lang="scss" scoped>

	[data-component='card-select'] {
		[data-component='select-field'] {
			width: 140px;
		}
	}

</style>
